import React from 'react';
import Button from 'ROOT/src/components/formElements/Button';
import sAction from 'sAction';
import ResetPass_orig from 'ROOT/src/components/login/ResetPass';

export default class ResetPass extends ResetPass_orig {
    getForm() {
        return (
            <React.Fragment>
                <tr><td colSpan="2"></td></tr>
                <tr className="portalInputLine">
                    <td><label htmlFor="pass">{sAction.translate('LBL_NEW_PASSWORD')}</label></td>
                    <td>
                        {this.state.passMessage ?
                            this.getErrorMessage(this.state.passMessage) :
                            null}
                        <input
                            type="password"
                            id="pass"
                            ref={this.pass}
                        />
                    </td>
                </tr>
                <tr className="portalInputLine">
                    <td>{sAction.translate('LBL_NEW_PASSWORD_AGAIN')}</td>
                    <td>
                        {this.state.passAgainMessage ?
                            this.getErrorMessage(this.state.passAgainMessage) :
                            null}
                        <input
                            type="password"
                            ref={this.passAgain}
                        />
                    </td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <div className="loginButtonContainer">
                            <Button
                                className="loginButton"
                                onClick={() => this.resetPassword()}
                            >
                                {sAction.translate('LBL_CONFIRM_NEW_PASSWORD')}
                            </Button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <div className="loginButtonContainer">
                            {sAction.translate('LBL_FORGOTTEN_PASSWORD_RETURN')}
              &nbsp;
                            <a onClick={() => this.props.goToLogin()}>
                                {sAction.translate('LBL_FORGOTTEN_PASSWORD_RETURN_BUTTON')}
                            </a>
                        </div>
                    </td>
                </tr>
            </React.Fragment>
        );
    }
}
